import { render, staticRenderFns } from "./SubscribeComponent.vue?vue&type=template&id=bd0ed2c0&"
import script from "./SubscribeComponent.vue?vue&type=script&lang=js&"
export * from "./SubscribeComponent.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeComponent.vue?vue&type=style&index=0&id=bd0ed2c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports